import SeoContentList from './SeoContentList.container';

export default SeoContentList;
